// reducers/index.js
import { combineReducers } from "redux"
import { authReducer } from "./authReducer"
import {
  facilitySFReducer,
  getFacilityDBReducer,
  AddFacilityReducer,
  adminListReducer,
  worksiteReducer,
  mainNavReducer,
  fetchFacilityUserReducer,
  postFacilityUserReducer,
  facilityUserDBReducer,
  editFacilityReducer,
  editFacilityUserReducer,
} from "./facilityReducer"
import {
  dashboardNavReducer,
  dsReportReducer,
  getDashboardReportsReducer,
  selectionReducer,
} from "./dashboardReducers"
import roleReducer from "./rollReducer"
import {
  schedulingReducer,
  profileReducer,
  shiftReducer,
  documentReducer,
  scProfileNavReducer,
  viewDocumentReducer,
  calendarReducer,
  shiftsReducer,
  credentialingReducer,
} from "./schedulingReducer"
import {
  reportReducer,
  reportByClientReducer,
  adminFacilityReducer,
} from "./facilityAdminReducers"
import {
  spendManagementReducer,
  spProfileNavReducer,
  SpProfileReducer,
  timeEntiresReducer,
  documentSpendReducer,
  viewSpendDocumentReducer,
  spIvProfileNavReducer,
  spMainNavReducer,
  timesFilterReducer,
} from "./spendManagementReducers"
import {
  InvExpensesReducer,
  InvTimeEntiresReducer,
  spendMtgInvoiceReducer,
  SpIvDocumentReducer,
  SpIvProfileReducer,
  viewSpIvDocumentReducer,
} from "./spendMtgInvoiceReducers";
import {dynamicTableConfigReducer} from "./dynamicTableConfigReducer";
import supportReducer from "./supportReducer"
import { userReducer } from "./userReducer"
import { masterCalendarReducer } from "./masterCalendarReducer"
import tableFiltersReducer from "./tableFiltersReducer"
import themeReducer from "./themeReducer"
import kbReducer from "./kbReducer"

export const rootReducer = combineReducers({
  UserInfo: authReducer,
  hospital: facilitySFReducer,
  admin: adminListReducer,
  editFacility: editFacilityReducer,
  facilityList: getFacilityDBReducer,
  addFacility: AddFacilityReducer,
  worksite: worksiteReducer,
  dashboardReportList: getDashboardReportsReducer,
  selection: selectionReducer,
  rolePermission: roleReducer,
  scheduling: schedulingReducer,
  mainNavigation: mainNavReducer,
  dashboardNavigation: dashboardNavReducer,
  shifts: shiftReducer,
  profile: profileReducer,
  document: documentReducer,
  profilenavigation: scProfileNavReducer,
  filterStoring: shiftsReducer,
  timesheetFilter: timesFilterReducer,
  dsReport: dsReportReducer,
  tableauReport: reportReducer,
  reportName: reportByClientReducer,
  adminFacilityData: adminFacilityReducer,
  getFacilityUser: fetchFacilityUserReducer,
  postFacilityUser: postFacilityUserReducer,
  editFacilityUser: editFacilityUserReducer,
  viewDocument: viewDocumentReducer,
  spendManagement: spendManagementReducer,
  timeEntries: timeEntiresReducer,
  SpProfile: SpProfileReducer,
  spMainNavigation: spMainNavReducer,
  spProfilenavigation: spProfileNavReducer,
  spProfileIvnavigation: spIvProfileNavReducer,
  facilityUserDB: facilityUserDBReducer,
  spendDocuments: documentSpendReducer,
  spendViewDocument: viewSpendDocumentReducer,
  spendMtgInvoice: spendMtgInvoiceReducer,
  spIvProfile: SpIvProfileReducer,
  spIvDocument: SpIvDocumentReducer,
  spIvViewDocument: viewSpIvDocumentReducer,
  invTimeEntries: InvTimeEntiresReducer,
  invExpenses: InvExpensesReducer,
  calendar: calendarReducer,
  credentialing: credentialingReducer,
  dynamicTableConfig: dynamicTableConfigReducer,
  support: supportReducer,
  user: userReducer,
  masterCalendar: masterCalendarReducer,
  tableFilters: tableFiltersReducer,
  theme: themeReducer,
  kb: kbReducer,
});

export default rootReducer
